import React from "react";

const SearchableDropdown = ({ label, value, options, onSelect, searchValue, onSearchChange, isOpen, onToggle, isLoading, isEmpty }) => {
  const filtered = React.useMemo(() => {
    if (!Array.isArray(options) || options.length === 0) return [];
    return options.filter(opt =>
      opt?.label?.toLowerCase().includes(searchValue?.toLowerCase() || '')
    );
  }, [options, searchValue]);

  return (
    <div className="flex flex-col gap-1">
      <label className="text-sm font-medium text-gray-700 dark:text-gray-300">{label}</label>
      <div className="relative">
        <button
          onClick={onToggle}
          disabled={isEmpty || isLoading}
          className="w-full border border-gray-300 rounded px-3 py-2 text-left flex items-center justify-between bg-white hover:bg-gray-50 disabled:bg-gray-100 disabled:cursor-not-allowed bg-white text-gray-900 placeholder-gray-400 focus:ring-2 focus:ring-blue-500
 dark:bg-slate-800 dark:border-slate-600 dark:text-white dark:placeholder-gray-500"
        >
          <span className="text-sm">{value || (isEmpty ? 'Select category first' : 'Select...')}</span>
          <span className="text-xs">{isLoading ? '⟳' : <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" data-slot="icon" className="h-4 w-4 transition "><path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5"></path></svg>}</span>
        </button>
        {isOpen && options.length > 0 && (
          <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-300 rounded shadow-lg z-10 bg-white text-gray-900 placeholder-gray-400 focus:ring-2 focus:ring-blue-500
 dark:bg-slate-800 dark:border-slate-600 dark:text-white dark:placeholder-gray-500">
            <div className="p-2 border-b border-gray-200 dark:border-slate-600">
              <input
                type="text"
                placeholder="Search..."
                value={searchValue}
                onChange={(e) => onSearchChange(e.target.value)}
                className="w-full border border-gray-300 rounded px-2 py-1 text-sm bg-white text-gray-900 placeholder-gray-400 focus:ring-2 focus:ring-blue-500
 dark:bg-slate-800 dark:border-slate-600 dark:text-white dark:placeholder-gray-500"
                autoFocus
              />
            </div>
            <div className="max-h-40 overflow-y-auto">
              {filtered.map((opt) => (
                <button
                  key={opt.id || opt.value}
                  onClick={() => onSelect(opt)}
                  className="w-full text-left px-3 py-2 hover:bg-blue-100 text-sm flex items-center gap-2"
                >
                  {/* {opt.thumbnail && (
                    <img
                      src={opt.thumbnail}
                      alt={opt.label || opt.name}
                      className="w-6 h-6 rounded object-cover"
                     // onError={(e) => e.target.style.display = 'none'}
                    />
                  )} */}
                  <span>{opt.label || opt.name}</span>
                </button>
              ))}
              {filtered.length === 0 && (
                <div className="px-3 py-2 text-sm text-gray-500">No results found</div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchableDropdown;